const buildResolutionMap = (costs) => Object.freeze(costs);

export const KLING_V3_CREDIT_COSTS = Object.freeze({
  standard: Object.freeze({
    default: buildResolutionMap({
      '720p': 28,
      '1080p': 36,
      '4k': 180,
    }),
    audio: buildResolutionMap({
      '720p': 44,
      '1080p': 56,
      '4k': 180,
    }),
  }),
  omni: Object.freeze({
    default: buildResolutionMap({
      '720p': 28,
      '1080p': 36,
      '4k': 180,
    }),
    audio: buildResolutionMap({
      '720p': 36,
      '1080p': 48,
      '4k': 180,
    }),
    videoReference: buildResolutionMap({
      '720p': 44,
      '1080p': 56,
      '4k': 180,
    }),
  }),
});
